var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrows({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title827"
  }, "text-height") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title827"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 17,24 h 4 l -5,6 -5,-6 h 4 V 8 h -4 l 5,-6 5,6 h -4 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrows);
export default __webpack_public_path__ + "static/media/double-arrows.c74a97fa.svg";
export { ForwardRef as ReactComponent };